var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.82404 7.0855L8.06675 3.84279L7.53967 3.32717L4.82404 6.04279L3.44904 4.66779L2.93342 5.18342L4.82404 7.0855ZM5.50008 9.58342C4.87369 9.58342 4.28168 9.4631 3.72404 9.22248C3.1664 8.98185 2.67942 8.65338 2.2631 8.23706C1.84678 7.82074 1.51831 7.33376 1.27769 6.77612C1.03706 6.21848 0.916748 5.62647 0.916748 5.00008C0.916748 4.36605 1.03706 3.77022 1.27769 3.21258C1.51831 2.65494 1.84678 2.16987 2.2631 1.75737C2.67942 1.34487 3.1664 1.01831 3.72404 0.777686C4.28168 0.537061 4.87369 0.416748 5.50008 0.416748C6.13411 0.416748 6.72994 0.537061 7.28758 0.777686C7.84522 1.01831 8.33029 1.34487 8.74279 1.75737C9.15529 2.16987 9.48185 2.65494 9.72248 3.21258C9.9631 3.77022 10.0834 4.36605 10.0834 5.00008C10.0834 5.62647 9.9631 6.21848 9.72248 6.77612C9.48185 7.33376 9.15529 7.82074 8.74279 8.23706C8.33029 8.65338 7.84522 8.98185 7.28758 9.22248C6.72994 9.4631 6.13411 9.58342 5.50008 9.58342Z",
    fill: "#33CC66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenMark);
export default __webpack_public_path__ + "static/media/greenMark.f06c6dde9d08b2fde02dc03d23e51c24.svg";
export { ForwardRef as ReactComponent };